<template>
	<div class="user-management-container">
		<tabel-panel  
			ref="tabel" :rowTemplate="rowTemplate" api="ContractSearch"  
			:condition="conditionData" editType="pop" :autoSearch="true"
			:showCancelButton="false"
			@popConfirmButtonClick="popConfirmButtonClick" :clickRowSelected="false" 
			@customerRowDblClick="customerRowDblClick" :popToCustomer="true">
			
			<template v-slot:tabelTitleLeft>
				<div>备机列表</div>
			</template>
			<template v-slot:tabelTitleRight>
				<add-button @buttonClick="">
					添加
				</add-button>
			</template>
			
			<template v-slot:condition style="height: 200px;">
				<text-field
					v-model:value="conditionData.cid" 
					labelText="客户:"
					:clearable="true" type="select"
					:selectRemoteSearchData="selectOuguName"
					class="condition-container-input">
				</text-field>
				
				<text-field
					v-model:value="conditionData.did" 
					labelText="合同类型:"
					:clearable="true" type="select"
					:selectRemoteSearchData="selectOuguBrand"
					class="condition-container-input">
				</text-field>
				
				<text-field
					v-model:value="conditionData.con" 
					labelText="合同编号:"
					class="condition-container-input">
				</text-field>
				
				<text-field
					v-model:value="conditionData.buyDate" 
					type="date"
					labelText="购买日期:"
					clearable
					class="condition-container-input">
				</text-field>
				
				<text-field
					v-model:value="conditionData.endDate" 
					type="date"
					labelText="截至日期:"
					clearable
					class="condition-container-input">
				</text-field>
				
				<text-field
					v-model:value="conditionData.sn" 
					labelText="SN号;"
					class="condition-container-input">
				</text-field>
				
			</template>
			
			 <template v-slot:snBtn="$opData">
			 	<div class="opration">
			 		<control-button class="item"
			 			@buttonClick="delSingleUser($opData.data.row)">SN</control-button>
			 	</div>
			 </template>
			 
			<template v-slot:repairBtn="$opData">
				<div class="opration">
					<control-button class="item"
						@buttonClick="delSingleUser($opData.data.row)">照片</control-button>
				</div>
			</template>
			
			<template v-slot:goBackBtn="$opData">
				<div class="opration">
					<control-button class="item"
						@buttonClick="delSingleUser($opData.data.row)">删除</control-button>
				</div>
			</template>
		</tabel-panel>, 
		
		<pop-dialog id="loadBOX" @confirmClick="popUploadClick" 
			v-if="loadShow" ref="getMenuList" 
			:meta="popDialogList" detailShowType="data" 
			@dialogClose="handDialogClose">
			
			<div class="oprationTree">
				<div class="detailed-box">
					<div class="detailed-title"> 设备维修编辑信息 </div>
					<div>内容</div>
					<div class="pop-dialogClose" @click="handDialogClose">
						<i class="el-icon-close"></i>
					</div>
				</div>
			</div>
		</pop-dialog>
	</div>
</template>

<script>
	import textField from "@/components/textField.vue"
	import delButton from "@/components/delButton.vue"
	import addButton from "@/components/addButton.vue"
	import controlButton from "@/components/controlButton.vue"
	import updateButton from "@/components/updateButton.vue"
	import tabelPanel from "@/components/tabelPanel.vue"
	import popDialog from "@/components/popDialog.vue"
	import tableApi from "@/api/tabel.js"
	import {
		symptomEdit,
		RepairProductCancel,
		MoneySave,
		BackFactorySave,
		RepairSave
	} from "@/api/index.js"
	import {
		errMsg,
		successMsg
	} from "@/notify/index.js"

	export default {
		name: "CusRepairList",
		components: {
			textField,
			addButton,
			delButton,
			tabelPanel,
			popDialog,
			updateButton,
			controlButton
		},
		data() {
			 
			
			
			const selectRemoteSearchData = async (pageSize,currentPageIndex,parms) => {
				if(parms.ProductId == null || parms == null){
					return {
						total:0,
						data:null
					}
				}
				let source = await tableApi.modelSelect({
						ProductCategoryId:parms.ProductId,
					});
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						Name
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg( source.message)
				}
			}
			
			const selectRemoteSearchData2 = async (pageSize,currentPageIndex,parms) => {
				//产品select列表
				if(parms.BrandId == null || parms == null){
					return {
						total:0,
						data:null
					}
				}
				let source = await tableApi.ProductSelect({Bid:parms.BrandId});
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						Name
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(source.message)
				}
			}
			
			return {
				checked: false,
				resource: '',
				radio: null,
				inputValue: "明细",
				activeName: 'first',
				loadShow: false,
				rowData: null,
				rowTemplate: [ 
					{
						headerLabel: "客户",
						editable: true,
						dataIndex: "CompanyName"
					},{
						headerLabel: "合同类型",
						dataIndex: "DicInfoName"
					},{
						headerLabel: "合同编号",
						dataIndex: "ContractNo"
					},{
						headerLabel: "购买日期",
						dataIndex: "BuyDate"
					},{
						headerLabel: "截至日期",
						dataIndex: "EndDate"
					},{
						headerLabel: "月限",
						dataIndex: "Month"
					},{
						headerLabel: "描述",
						dataIndex: "Appendix"
					},{
						headerLabel: "SN",
						slot: "snBtn",
						width: "100"
					},{
						headerLabel: "合同",
						slot: "repairBtn",
						width: "100"
					},{
						headerLabel: "删除",
						slot: "goBackBtn",
						width: "100"
					}],
				conditionData: {
					cid: null,
					did: null,
					con: null,
					buyDate: null,
					endDate: null,
					sn: null
					// cid	Int	公司id
					// did	int	品牌Id
					// con	string	合同号
					// buyDate	String	购买日期
					// endDate	String	截止日期
					// sn	String	SN号

				},
				CusPriceSave:{
					Id: null ,				// id	Int	id	是
					IsWarranty: false ,		// IsWarranty	Bool	是否在保修范围内	
					Level_Id: null ,			// level	Int	维修级别	是
					App1: 0 ,			// App1	Decimal	邮费	
					App2: 0 ,			// App2	Decimal	折扣	
					App3: 0 ,			// App3	Int	工时	
					App4: 0 ,			// App4	Decimal	总计	
					CusPrice: 0 ,		// CusPrice	Decimal	客户报价	是
					CusPriceMethod: null ,	// CusPriceMethod	Int	客户报价方式	
					CusPayMethod: null ,	// CusPayMethod	Int	客户付款方式	
					IsAgreePrice: false ,	// IsAgreePrice	Bool	是否同意价格	
					IsGiveUp: false ,		// IsGiveUp	Bool	是否放弃维修	
				},
				CusPriceSaveR:{
					Id: null ,				// id	Int	id	是
					IsWarranty: false ,		// IsWarranty	Bool	是否在保修范围内	
					Level_Id: null ,			// level	Int	维修级别	是
					App1: 0 ,			// App1	Decimal	邮费	
					App2: 0 ,			// App2	Decimal	折扣	
					App3: 0 ,			// App3	Int	工时	
					App4: 0 ,			// App4	Decimal	总计	
					CusPrice: 0 ,		// CusPrice	Decimal	客户报价	是
					CusPriceMethod: null ,	// CusPriceMethod	Int	客户报价方式	
					CusPayMethod: null ,	// CusPayMethod	Int	客户付款方式	
					IsAgreePrice: false ,	// IsAgreePrice	Bool	是否同意价格	
					IsGiveUp: false ,		// IsGiveUp	Bool	是否放弃维修	
				},
				
			}
		},
		methods: {
			// rowData.FactoryBack_Id
			rowDataNull(v){
				// let v == 0 ? null : v
				return v
			},
			handDialogClose(){
				this.loadShow=false
				this.activeName = 'first'
			},
			getTit1(v){
				// 待报价	3031---> 报价 
				// 维修中	3029---> 维修
				// 返厂		3037---> 返厂中
				// 缓存区	3027---> 报价,返厂
				if( v === 3027 || v === 3031){
					return false
				}
				return true
			},
			getTit2(v){
				if(v === 3037){
					return false
				}
				return true
			},
			getTit3(v){
				if(v === 3037){
					return false
				}
				return true
			},
			getTit4(v){
				if( v === 3037 || v === 3027){
					return false
				}
				return true
			},
			async selectLevel_Id()  {
				let source = await tableApi.repairLevel();
				if (source.code == 0) {
					
					let data = source.data.list.map(({
						id,
						Name 
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(this, source.message)
				}
			},
			async selectOuguName()  {
				let source = await tableApi.CompanyInfo();
				if (source.code == 0) {
					let data = source.data.list.map(({
						Company_Id,
						CompName 
					}) => {
						return {
							label: CompName,
							value: Company_Id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(this, source.message)
				}
			},
			async selectOuguBrand()  {
				let source = await tableApi.BrandSelect();
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						Name
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(this, source.message)
				}
			},
			async selectOuguNameProduct()  {
				let source = await tableApi.ProductSelect();
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						Name
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(this, source.message)
				}
			},
			async selectOuguNameModelSelect()  {
				let source = await tableApi.modelSelect();
				if (source.code == 0) {
					let data = source.data.list.map(({
						id,
						Name
					}) => {
						return {
							label: Name,
							value: id
						}
					})
					let total = 0;
					return {
						total,
						data
					}
				} else {
					errMsg(this, source.message)
				}
			},
			reloadData() {
				this.$refs.tabel.reloadData()
			},
			delSingleUser({ row }) {
				let id = row.Id
				console.log('id--', row.Id)
				// RepairProductCancel({id}).then(data => {
				// 	if (data.code == 0) {
				// 		successMsg(data.message)
				// 		this.reloadData()
				// 	} else {
				// 		errMsg( data.message)
				// 	}
				// })
			},
			//弹层事件
			popConfirmButtonClick({
				slotData
			}) {
				console.log(slotData)
			},
			customerRowDblClick(row){
				console.log('row:',row)
				this.loadShow = true
				this.rowData = row
				this.$nextTick(()=>{
					this.$refs.getMenuList.showPopDialog(row, "报修明细","slot")
				})
				console.log('row:',this.rowData)
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";

	#suerSwitch .el-switch__core{
		width: 26px;
	}
	
	.el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
		background: red;
	}
	
	.user-management-container {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		overflow: hidden;
		align-items: center;
		align-content: center;
		@include background_color("user-management-bg-color");
		 
		.del {
			margin-left: 10px;
		}

		.condition-container-input {
			width: 270px;
		}

		.opration {
			height: 100%;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			align-content: center;

			.item {
				&:nth-child(n+1) {
					margin-left: 10px;
				}
			}
		}
		.menuPowerBtn{
			// color:rgb(255, 255, 255)!important;
			// background:rgb(100,134,232)!important;
		}
		.menuPowerBOX{
			.el-button--default{
				width:90px;
				height:30px;
				color: #ffffff;
				background: rgb(100,134,232);
				border-radius: 4px;
			}
			.item {
				height: 30px;
				color: #ffffff !important;
				padding:10px 15px !important;
				background: rgb(100,134,232) !important; 
			}
		}
		#loadBOX{
			width: 100%;
			height: 100%;
			
			.text-field-container{
				display: flex;
				
			}
			.label-container{
			    display: flex;
			    width: fit-content;
			    height: fit-content;
			    padding: 10px;
			    box-sizing: border-box;
			}
		}
		.pop-dialog-conver{
			background:yellow ;
		}
		.pop-dialog-container{
			
		}
		.oprationTree{
			background-color: #ecf5ff;
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			padding: 25px 20px 15px 20px;
			
			.detailed-box{
				width: 100%;
				height: 100%;
				position: relative;
				border: 1px solid #99bce8;
				background-color: #f4f7f6;
				border-radius: 10px;
				
				
				.detailed-title{
					font-family:Microsoft YaHei;
					font-weight: normal;
					padding: 10px;
				}
				
				.text-field-container{
					background: #f4f7f6!important;
					margin: 10px 20px;
					width: 320px;
				}
				.user-management-container .condition-container-input{
					margin: 5px 10px;
				}
			
				.pop-dialogClose{
					position: absolute;
					top: 20px;
					right: 15px;
					
					.el-icon-close:before{
						font-size: 28px;
					}
					.el-icon-close:hover{
						color: #f92323;
					}
				}
			}
		}
		.pop-dialog-conver{
			display: block!important;
			width: 100%!important;
			height: 100%!important;
			
		}
		.control-button-container{
			margin: 25px auto;
			color: #409EFF;
		}
		.el-radio{
			display: flex;
			width: 300px;
			justify-content: space-evenly;
			flex-direction: row-reverse;
			padding: 20px 20px;
		}
		.el-radio-group{
			width: 100%;
			display: inherit;
			font-family: hanSan !important;
			font-size: 20px;
		}
		
	}
</style>
